import { GiftCardEndpoints } from '@/modules/arbela-gift-card/gift-card/api/giftCardEndpoints'

/**
 * Gift Card endpoint instance
 * instantiate Gift Card api class with different api path
 */
export const giftCardEndpoints = new GiftCardEndpoints()
